module.exports = __webpack_public_path__ + "img/protact.a4988bdb.png";